<!-- 虫情监测详情 -->
<template>
    <div class="content">
        <!-- 左边 -->
        <div class="left">
            <!-- 设备信息 -->
            <div class="shebei">
                <div class="item">
                    <div class="title">
                        <div class="text">设备信息</div>
                        <div class="select" v-if="equipmentData">
                            <el-select v-model="equipmentName" placeholder="请选择" @change="changeEquipment">
                                <el-option
                                v-for="item in equipmentList"
                                :key="item.deviceId"
                                :label="item.name"
                                :value="item.deviceId">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="value">
                        <div class="left" v-if="equipmentData">
                            <p class="text">设备ID：<span class="num">{{ equipmentData.deviceId }}</span></p>
                            <p class="text">设备名称：{{equipmentData.name}}</p>
                            <p class="text">设备状态：{{equipmentData.ws == 0 ? "离线" : "在线"}}</p>
                            <p class="text">设备定位：{{ equipmentData.address }}</p>
                            <p class="text">最新上报时间：{{ equipmentData.newUploadTime }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 环境温度湿度 -->
            <div class="weather">
                <cqLeftEchats2 :deviceId="deviceId"/>
            </div>
            <!-- 虫情趋势 -->
            <div class="trend">
                <cqLeftEchats3 :deviceId="deviceId"/>
            </div>
        </div>
        <!-- 中间 -->
        <!-- <div class="center">
            <div class="tab">
                <el-radio-group v-model="radio1">
                    <el-radio-button size="medium" label="害虫迁徙图"></el-radio-button>
                    <el-radio-button size="medium" label="害虫分布图"></el-radio-button>
                </el-radio-group>
            </div>
            <div class="query">
                <div class="left">
                    <div class="year">
                        <div class="choose">
                            <span>统计年份：</span>
                            <el-date-picker
                            v-model="year"
                            size="large"
                            type="year"
                            placeholder="选择年">
                            </el-date-picker>
                        </div>
                        <div class="choose">
                            <span>害虫种类：</span>
                            <el-select v-model="insectType" placeholder="请选择">
                            <el-option
                                v-for="item in insectTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="stage">
                        <span>虫情期：</span>
                        <el-radio-group v-model="stage">
                            <el-radio :label="1">始见期</el-radio>
                            <el-radio :label="2">高峰期</el-radio>
                            <el-radio :label="3">终见期</el-radio>
                        </el-radio-group>
                        <i class="el-icon-search">查询</i>
                    </div>
                </div>
                
            </div>
        </div> -->
        <!-- 右边 -->
        <div class="right">
            <!-- 虫情趋势信息 -->
            <div class="trend">
                <cqRightEchats1 :deviceId="deviceId"/>
            </div>
            <!-- 害虫占比 -->
            <div class="proportion">
                <cqRightEchats2 :deviceId="deviceId"/>
            </div>
            <!-- 害虫排名 -->
            <div class="ranking">
                <cqRightEchats3 :deviceId="deviceId"/>
            </div>
        </div>
    </div>
</template>
  
<script>
import { getCQ_equipment } from '../api/api'
import cqLeftEchats2 from "../components/echart/cqLeftEchats2.vue"
import cqLeftEchats3 from "../components/echart/cqLeftEchats3.vue"
import cqRightEchats1 from "../components/echart/cqRightEchats1.vue"
import cqRightEchats2 from "../components/echart/cqRightEchats2.vue"
import cqRightEchats3 from "../components/echart/cqRightEchats3.vue"
export default {
    components: {
        cqLeftEchats2,
        cqLeftEchats3,
        cqRightEchats1,
        cqRightEchats2,
        cqRightEchats3,
    },
    data () {
      return {
        equipmentData:{},
        equipmentList:[],
        equipmentName:"",
        deviceId:"",
        // 标题栏选择
        radio1: '害虫迁徙图',
        // 年份选择
        year:"2023",   
        // 害虫分类列表
        insectType:"",
        insectTypeList:[
            {value: '选项1',label: '一点金刚钻'},
            {value: '选项2',label: '东方粘虫'},
            {value: '选项3',label: '丝棉木金星大尺蛾'},
            {value: '选项4',label: '丝棉木尺蛾'},
            {value: '选项5  ',label: '丝棉木金星尺蛾'},
        ],
        // 虫情时期选择
        stage:"",
      }
    },
    created () { 
        this.projectId = JSON.parse(localStorage.getItem("projectId"))
        if(this.projectId ){
            this.getEquipment(this.projectId)
        }
    },
    mounted () { 
        let _this = this
        window.addEventListener('setItemEvent', function(e) {
            const newdata = JSON.parse(e.newValue)
            console.log('值改变了',newdata)
            _this.getEquipment(newdata)
        })
    },
    methods: {
        // 获取设备信息
        async  getEquipment(projectId){
            let res = await getCQ_equipment({
                projectId,
            })
            console.log(res, "虫情设备");
            if(res.code == 200){
                this.equipmentList = res.data
                this.equipmentData = res.data[0]
                this.equipmentName = res.data ? res.data[0].name : ""
                this.deviceId = res.data[0].deviceId
                // window.localStorage.setItem('deviceId', JSON.stringify(res.data[0].deviceId))
            }
        },

        // 切换设备
        changeEquipment(e){
            console.log(e);
            this.deviceId = e
            this.equipmentList.forEach(item => {
                if(item.deviceId == e){
                    this.equipmentData = item
                }
            })
        },

        // 选择环境温度湿度时间
        chooseWeatherTime(e){
            window.localStorage.setItem('deviceId', JSON.stringify(e))
        }
    },
    
}
</script>
  
<style lang="scss" scoped>
.content{
    position: relative;
    width: 100%;
    height: 100%;
    background: url("../assets/addressbg.png") no-repeat;
    background-size: 100% 100%;
    color: #fff;
    padding: 26px 200px 31px;
    display: flex;
    justify-content: space-between;
    .item{
        width: 530px;
        padding: 10px 15px 25px 28px;
        margin-bottom: 20px;
        border-radius: 10px;
        background-color: rgba(0, 0, 0, 0.5);
        .title{
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 20px;
            line-height: 30px;
            font-family: SourceHanSansSC-regular;
            margin-bottom: 25px;
        }
        .value{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .text{
                font-size: 16px;
                line-height: 23px;
                margin-bottom: 15px;
                .num{
                    padding: 5px 8px;
                    background-color: rgba(255, 255, 255, 0.2);
                }
            }
            .info{
                display: flex;
                align-items: center;
                .left{
                    >img{
                       width: 60px;
                       height: 60px;
                    }
                }
                .right{
                    width: 100px;
                    text-align: center;
                    p{
                        font-size: 14px;
                        line-height: 28px;
                    }
                }
            }
        }
    }
    .left{
        .shebei{
            margin-bottom: 20px;
        }
        .weather{
            margin-bottom: 20px;
        }
    }

    .center{
        .tab{
            padding-top: 60px;
            width: 100%;
            text-align: center;
            .el-radio-group{
                ::v-deep .el-radio-button__inner{
                    width: 207px;
                    height: 76px;
                    line-height: 54px;
                    margin-left: 50px;
                    font-size: 28px;
                    border-radius: 17px;
                }
            }
        }
        .query{
            padding-top: 50px;
            padding-left: 20px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .left{
                .year{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .choose{
                        margin-right: 50px;
                        display: flex;
                        align-items: center;
                        >span{
                            width: 130px;
                            font-size: 26px;
                            font-family: SourceHanSansSC-regular;
                            line-height: 38px;
                        }
                        ::v-deep.el-input__inner{
                            font-size: 24px;
                        }
                        ::v-deep.el-input{
                            width: 200px ;
                        }
                    }
                }
                .stage{
                    margin-top: 20px;
                    display: flex;
                    align-items: center;
                    >span{
                        font-size: 26px;
                        font-family: SourceHanSansSC-regular;
                        line-height: 38px;
                    }
                    
                    ::v-deep.el-radio-group{
                        .el-radio{
                            line-height: 28px;
                        }
                        .el-radio__inner{
                            width: 24px;  
                            height: 24px;
                        }
                        .el-radio__label{
                            font-size: 24px;
                            color: #fff;
                        }
                    }
                    >i{
                        font-size: 26px;
                        margin-left: 50px;
                    }
                }
            }
        }
    }

    .right{
        .trend{
            margin-bottom: 30px;
        }
        .proportion{
            margin-bottom: 22px;
        }
    }
}
  
  
</style>
  